import { apiClient } from './api';

/**
 * Finance Service
 * Handles all finance-related API calls
 */
export const financeService = {
  /**
   * Get financial overview
   * @param {Object} params - Query parameters (account_id)
   * @returns {Promise} Financial overview data
   */
  getFinancialOverview: (params = {}) => {
    return apiClient.get('/finance/overview', params);
  },
};
